module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-side"
  }, [_c('a', {
    staticClass: "left-avatar",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-nickname"
  }, [_vm._v("凡人凡物")])]), _vm._v(" "), _c('div', {
    staticClass: "left-list"
  }, [_c('a', {
    staticClass: "left-sub",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("意见反馈")])]), _vm._v(" "), _c('a', {
    staticClass: "left-sub",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("使用条款")])]), _vm._v(" "), _c('a', {
    staticClass: "left-sub",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("隐私声明")])]), _vm._v(" "), _c('a', {
    staticClass: "left-sub",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("帮助")])]), _vm._v(" "), _c('a', {
    staticClass: "left-sub",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("应用设置")])])]), _vm._v(" "), _c('a', {
    staticClass: "left-foot",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("版本：1.0.0")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d80104a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftSide.vue
// module id = 55
// module chunks = 0